let language = {
    DETAIL_SPECIFICATION_IMAGE: "图像特性",
    DETAIL_SEE_DETAILS: "[查看详情]",
    
}

export { language }